<template>
        <v-navigation-drawer
        width="212"
        mobile-breakpoint="960"
        v-model="mini"
        class="menu_nav"
        app
      >
      <!-- drawer -->
      <!-- :mini-variant.sync="mini" -->
      <v-list-item class="h64" style="margin-bottom: 10px;padding:0;">
        <!-- @click.stop="changeMini" -->
        <div class="logo_icon_wrapper">
            <!-- <div class="icon_box hand" @click="goPage('/home')"> -->
               <div class="icon_box hand">
              <div class="box_items">
                <!-- <img src="../assets/images/icons/lingang_logo.svg" alt=""> -->
                <img src="../assets/images/common/logo2.svg" alt="">
                <div class="text">专利应用管理平台</div>
              </div>
              <!-- <div class="logo1"></div>
              <div class="logo2"></div> -->
            </div>
        </div>
        <!-- <v-list-item-title>知嘟嘟</v-list-item-title> -->
      </v-list-item>
      <!--<v-divider></v-divider>--->
      <v-list nav
        dense >
          <v-list-item-group
          v-model="item"
        >
        <v-list-item
          v-for="item in items"
          :key="item.title" 
          link
          @click="goPage(item.path)"
        >
          <v-list-item-icon>
            <span :class="'menus_icon '+ item.icon"></span>
            <!-- <v-icon class="nav_icon">{{ item.icon }}</v-icon> -->
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
</template>
<script>
 
  export default {
    data () {
      return {
        // drawer: null,
        // mini: true,
        item:'',
        items: [
          // { title: '系统主页', icon: 'chome_icon' ,path: '/chome'},
          // { title: '分类统计', icon: 'cate_icon' ,path: '/category'},
          // { title: '企业管理', icon: 'firm_icon' ,path: '/manage'},
          { title: '专利检索', icon: 'search_icon',path: '/research' },
          { title: '数据分析', icon: 'analy_icon' ,path: '/analyse'},
          { title: '工作空间', icon: 'space_icon',path: '/workSpace/work' },
            // { title: '工作空间', icon: 'work_icon',path: '/workSpace/work' },
          // { title: '企业画像', icon: 'business_icon' ,path: '/business'},
          { title: '分析报告', icon: 'report_icon' ,path: '/report'},
          { title: '专利管家', icon: 'manager_icon' ,path: '/manager'},
          // { title: '行业库', icon: 'mdi-database-search' ,path: ''},
          // { title: '专利管家', icon: 'mdi-pencil' ,path: ''},
          // { title: '风险监控', icon: 'mdi-monitor',path: '' },
          // { title: '侵权分析', icon: 'mdi-gavel' ,path: 'mdi-folder-search'},
        ],
        // mini: true,
      }
    },
    computed: {
      mini: {
        get(){
          return this.$store.state.mini;
        },
        set(v) {
          this.$store.commit('setMenuMini', v)
          // this.mini = v
        }
      },
      drawer: {
        get(){
          return this.$store.state.drawer || null;
        },
        set(v) {
          this.$store.commit('setMenuDraw', v)
        }
      }
    },
    watch: {
      item(val) {
        if(this.$vuetify.breakpoint.name=='sm' || this.$vuetify.breakpoint.name == 'xs') {
          this.$store.commit('setMenuMini', false)
        }
      },
      $route: {
          immediate: true, 
          handler(to,from) {
            if(to.path.indexOf('/analyse/classify/all')>-1 || to.path.indexOf('/user')>-1 || to.path.indexOf('/search/patentInfo')>-1 || to.path.indexOf('/search/result')>-1 || to.path.indexOf('/workSpace/detail')>-1) {
              this.mini = false
            }else {
              this.mini = true
            }
              //监听路由的值
                this.activeKey = to.path;
            // if(to.path == '/categoryDetail'){
            //   this.item = 1                 
            //   }

          }
      }
    },
    mounted() {
      this.getPathActive()
    },
    methods: {
      getPathActive() {
        let to = this.$route
        // if(to.path == '/chome') {
        //   this.item = 0
        // }
        // if(to.path == '/category') {
        //   this.item = 1
        // }
        //  if(to.path.indexOf('/category')>-1) {
        //   this.item = 1
        // }
        // if(to.path == '/manage') {
        //   this.item = 2
        // }
        if(to.path.indexOf('/search')>-1) {
          this.item = 0
        }
        if(to.path.indexOf('/analyse')>-1) {
          this.item = 1
        }
          // if(to.path.indexOf('/workSpace')>-1) {
        //   this.item = 2
        // }
        if(to.path.indexOf('/workSpace/work')>-1) {
          this.item = 2
        }
        // if(to.path == '/business') {
        //   this.item = 3
        // }
        if(to.path.indexOf('/report')>-1) {
          this.item = 3
        }
        if(to.path.indexOf('/manager')>-1) {
          this.item = 4
        }
        // if(to.path.indexOf('/knowledge')>-1) {
        //   this.item = 2
        // }
        //  if(to.path == '/knowledge') {
        //   this.item = 2
        // }
      },
      changeMini() {
        // this.mini = !this.mini
        this.$store.commit('setMenuMini', !this.mini)
      },
      goPage(path) {
        this.$router.push({
          path: path
        })
      }
    }
  }
</script>